import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { NgxPaginationModule } from 'ngx-pagination';
import { MdbAccordionModule } from 'src/lib/mdb5-adapted/public-api';

import { OverlayCardComponent } from './components/overlay-card/overlay-card.component';
import { PanelComponent } from './components/panel/panel.component';
import { NotificationComponent } from './notification/notification.component';
import { NotificationService } from './notification/notification.service';
import { SimpleNotificationComponent } from './notification/simple-notification.component';
import { LmsGridviewComponent } from './ui/lms-gridview/lms-gridview.component';
import { LmsPaginateComponent } from './ui/lms-paginate/lms-paginate.component';
import { LmsTableWrapperComponent } from './ui/lms-table-wrapper/lms-table-wrapper.component';
import { LmsClientSearchComponent } from './ui/lmsclient-search/lmsclient-search.component';
import { PageCardheadComponent } from './ui/pageheader-card/pageheader-card.component';

@NgModule({
  imports: [
    CommonModule,
    PageCardheadComponent,

    LmsClientSearchComponent,
    LmsGridviewComponent,
    LmsPaginateComponent,
    LmsTableWrapperComponent,
    NgxPaginationModule,
    NotificationComponent,
    SimpleNotificationComponent
   ],
  declarations: [
    OverlayCardComponent,
    PanelComponent,
  ],
  exports: [
    //OverlayCardComponent,
    PanelComponent,
    MdbAccordionModule,
    NotificationComponent,
    PageCardheadComponent,
    LmsClientSearchComponent,
    LmsGridviewComponent,
    LmsPaginateComponent,
    LmsTableWrapperComponent,
    SimpleNotificationComponent
  ],
  providers: [ NotificationService,
    { provide: ErrorHandler, useClass: SimpleNotificationComponent }

   ],
  schemas: [ NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA ],
})
export class SharedModule {}
